import { useContext, useEffect, useState } from "react";

import { AuthAppContext } from "components/root/auth-app-provider";
import { NAV_ELEMENTS } from "consts";

const HIDE_PROPERTY_CARRIERS = ["vave", "markel"];

export const useNavItems = () => {
  const { policy, userPolicyProperties } = useContext(AuthAppContext);

  const [navItems, setNavItems] = useState(NAV_ELEMENTS);
  const hidePropertyTab =
    policy?.isCommercial ||
    HIDE_PROPERTY_CARRIERS.includes(
      userPolicyProperties?.carrierGroup?.toLowerCase() ?? ""
    );

  useEffect(() => {
    setNavItems(
      NAV_ELEMENTS.filter(({ to }) => to !== "/my/property" || !hidePropertyTab)
    );
  }, [hidePropertyTab, policy]);

  return navItems;
};
